import React from 'react'
import ReactDOM from 'react-dom'

export default class ValuesProvider extends React.Component {
    render() {
        const {children, values} = this.props
        const childrenWithProps = React.Children.map(children, child => {
            return React.cloneElement(child, values)
        })

        return <React.Fragment>{childrenWithProps}</React.Fragment>
    }
}